var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1272 6.12718H7.87077V0.871794C7.87077 0.64058 7.77892 0.418836 7.61543 0.255343C7.45193 0.0918499 7.23019 0 6.99897 0C6.76776 0 6.54602 0.0918499 6.38252 0.255343C6.21903 0.418836 6.12718 0.64058 6.12718 0.871794V6.1282H0.871794C0.64058 6.1282 0.418836 6.22005 0.255343 6.38355C0.0918499 6.54704 0 6.76879 0 7C0 7.23121 0.0918499 7.45296 0.255343 7.61645C0.418836 7.77995 0.64058 7.87179 0.871794 7.87179H6.1282V13.1282C6.1282 13.3594 6.22005 13.5812 6.38355 13.7447C6.54704 13.9082 6.76879 14 7 14C7.23121 14 7.45296 13.9082 7.61645 13.7447C7.77995 13.5812 7.87179 13.3594 7.87179 13.1282V7.87077H13.1282C13.3594 7.87077 13.5812 7.77892 13.7447 7.61543C13.9082 7.45193 14 7.23019 14 6.99897C14 6.76776 13.9082 6.54602 13.7447 6.38252C13.5812 6.21903 13.3584 6.12718 13.1272 6.12718Z",
    fill: "#747478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.a892180df7cba426eb2c9367b9f6d39a.svg";
export { ForwardRef as ReactComponent };